// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hb-6";
export var emphasizeQuantity = "_hb-3";
export var flatBottomCorners = "_hb-5";
export var productImage = "_hb-0";
export var quantityContainer = "_hb-2";
export var tooltip = "_hb-1";
export var wrapAndEllipsesOverflow = "_hb-4";